import React from 'react';
import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';
const NotFound = () => (
  <Result
    status="404"
    title="404"
    subTitle="Siz izlagan sahifa mavjud emas yoki o‘chirib tashlangan."
    extra={<Link className='btn btn-primary' style={{textTransform: 'none'}} to={'/'} type="primary">Bosh sahifaga qaytish</Link>}
  />
);
export default NotFound;